// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2F2zn","visuallyhidden":"Hqh62","hide-text":"_1SSq_","center":"_2FwXv","noprint":"_2qca6","root":"_1xqaU"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-url/styles/default.scss
 ** module id = 1026
 ** module chunks = 2
 **/